/* RESPONSIBLE TEAM: team-ai-agent */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import Route from '@ember/routing/route';

export default Route.extend({
  beforeModel(transition) {
    let originalTarget = transition.targetName;
    let newTarget = originalTarget.replace(
      'apps.app.automation.resolution-bot.reporting',
      'apps.app.reports.customer-support.resolution-bot',
    );
    return this.replaceWith(newTarget);
  },
});
